import z from 'zod';
import { responseBaseSchema } from '../shared.types';

// ---- Zero Date Details ----

export const zeroDateDetailsRequestSchema = z.object({
    projectLocationId: z.number().int(),
    projectKey: z.string(),
});

export const zeroDateDetailsEpicDateSchema = z.object({
    projectEpicLabelId: z.number().int(),
    value: z.string().nullable().optional(),
});

export const zeroDateDetailsResponseSchema = z.object({
    zeroDate: z.string().nullable().optional(),
    openingDate: z.string().nullable().optional(),
    epicDates: z.array(zeroDateDetailsEpicDateSchema).nullable().optional().default([]),
});

// ---- Update Zero Date ----

export const DateShiftOption = {
    SimpleShift: 1,
    KeepCustomDates: 2,
    FullReset: 3,
} as const;

export const updateZeroDateEpicDateSchema = z.object({
    projectEpicLabelId: z.string(),
    value: z.string(),
});

export const updateZeroDateRequestSchema = z.object({
    projectLocationIds: z.array(z.number().int()).min(1),
    projectKey: z.string(),
    zeroDate: z.string().min(1),
    epicDates: z.array(updateZeroDateEpicDateSchema).default([]),
    dateShiftOption: z.number().int().min(1).max(3).default(DateShiftOption.SimpleShift),
    updateLocationOpeningDate: z.boolean().default(false),
    locationOpeningDate: z.string().nullable().default(null),
});

export const updateZeroDateResponseSchema = z.object({
    ...responseBaseSchema.shape,
    changedSomeLocations: z.boolean().optional().default(false),
    skippedSomeLocations: z.boolean().optional().default(false),
});

export type ZeroDateDetailsRequest = z.infer<typeof zeroDateDetailsRequestSchema>;
export type ZeroDateDetailsEpicDate = z.infer<typeof zeroDateDetailsEpicDateSchema>;
export type ZeroDateDetailsResponse = z.infer<typeof zeroDateDetailsResponseSchema>;
export type UpdateZeroDateEpicDate = z.infer<typeof updateZeroDateEpicDateSchema>;
export type UpdateZeroDateRequest = z.infer<typeof updateZeroDateRequestSchema>;
export type UpdateZeroDateResponse = z.infer<typeof updateZeroDateResponseSchema>;
